import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView } from '@/components/base'
import { StickyHeaderNavigation, SettingItem } from '@/components'
import { faqActionsList } from '@/constants/faqActions'
import useOffsets from '@/hooks/useOffsets'

export const FaqsScreen: React.FC = () => {
  const { t } = useTranslation()
  const offsets = useOffsets()
  const handleActionPress = (action: (typeof faqActionsList)[0]) => {
    if (action.link) {
      window.open(action.link, '_blank')
    }
  }

  return (
    <BaseView flex={1} bgColor="background.screen" className="h-full">
      {/* Fixed Header Navigation */}
      <StickyHeaderNavigation title={t('screens:faqs.title')} />

      {/* Scrollable Content */}
      <BaseView
        flex={1}
        px={12}
        style={{
          overflowY: 'auto',
          paddingBottom: '40px',
          paddingTop: offsets.top + 70,
        }}
      >
        <BaseView gap={8}>
          {faqActionsList.map((action) => (
            <SettingItem
              key={action.id}
              title={t(action.titleKey)}
              description={t(action.descriptionKey)}
              icon={action.icon}
              iconColor={action.iconColor}
              iconBgColor={action.iconBgColor}
              onPress={() => handleActionPress(action)}
            />
          ))}
        </BaseView>
      </BaseView>
    </BaseView>
  )
}

export default FaqsScreen
